// extracted by mini-css-extract-plugin
export default {"dangerZoneSection":"advanced_dangerZoneSection__HIefg"};